/* eslint-disable max-lines */
import { Badge, Card, Flex, Group, Loader, Modal } from '@mantine/core';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';
import Banner from '../../components/elements/Banner/Banner';
import Button from '../../components/elements/Button';
import DataTable from '../../components/elements/DataTable';
import LoadingBars from '../../components/elements/LoadingBars';
import DetailInfoMerchant from '../../components/fragments/DetailInfoMerchant';
import ModalMap from '../../components/fragments/ModalMap';
import ModalSettingMerchant from '../../components/fragments/ModalSettingMerchant';
import IcEye from '../../components/icons/IcEye';
import IcMap from '../../components/icons/IcMap';
import IconClose from '../../components/icons/IconClose';
import IconInfoFull from '../../components/icons/IconInfoFull';
import IconMap from '../../components/icons/IconMap';
import IconWarning from '../../components/icons/IconWarning';
import { AppContext, ModalContext, ToastrContext } from '../../contexts';
import { formatDateTime } from '../../utils/format';
import { blobToBase64 } from '../../utils/transform';
import {
  blockPinMerchant,
  createSuspendMerchant,
  fetchSettingMerchantDetail,
  fetchTransactionManualList,
  fetchUpdateAgen,
  identityImageUpload,
  openSuspendMerchant,
  resendMerchantAccount,
  setFormAction,
  setMessageAction,
  turnOffTransactionManual
} from './actions';
import { historyStatus } from './constants';
import styles from './styles.scoped.css';

function DetailSetting() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const { modalCtx, setModalCtx } = useContext(ModalContext);
  const {
    detail: { data, loading: detailLoading },
    blockPin,
    resend,
    deactivate,
    transactionManual: { data: histories },
    identity: { loading, message, success },
    agen,
    sync,
  } = useSelector((state) => state.merchantSetting);

  const { dataDetailUser } = useSelector((s) => s.pageBase);

  useEffect(() => {
    if (!loading && success) {
      setModalUpload(false);
      dispatch(fetchSettingMerchantDetail(id, isShowData));
      setToastr({
        visible: true,
        desc: (
          <span>
            Berhasil memperbarui <strong>Foto KTP</strong>
          </span>
        ),
        type: 'success',
      });
    }

    if (!loading && !success && message) {
      setModalUpload(false);
      setToastr({
        visible: true,
        desc: message,
        type: 'danger',
      });
    }
  }, [loading]);

  useEffect(() => {
    if (!sync.loading && sync.success) {
      dispatch(fetchSettingMerchantDetail(id, isShowData));
    }
  }, [sync]);

  useEffect(() => {
    if (!agen.loading && agen.success && agen.message) {
      setModal({ isOpen: false });
      dispatch(fetchSettingMerchantDetail(id, isShowData));
      setToastr({
        visible: true,
        desc: agen.message,
        type: 'success',
      });
    } else if (!agen.loading && !agen.success && agen.message) {
      setToastr({
        visible: true,
        desc: agen.message,
        type: 'danger',
      });
    }
  }, [agen.loading, agen.success]);

  const [modal, setModal] = useState({
    type: 'resend-account',
    isOpen: false,
  });
  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState('');
  const [showNotes, setShowNotes] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(0);
  const [modalInfo, setModalInfo] = useState(false);
  const [isTimer, setIsTimer] = useState(false);
  const expiryTime = new Date();
  const [showMap, setShowMap] = useState(false);
  const [modalUpdaload, setModalUpload] = useState(false);
  const [isShowData, setIsShowData] = useState(false);
  const { seconds, minutes, restart } = useTimer({
    expiryTimestamp: expiryTime,
    autoStart: false,
    onExpire: () => {
      setModalInfo(false);
      setIsTimer(false);
    },
  });

  const centerPoint = {
    lat: parseFloat(data?.coordinate?.split(',')[0]),
    lng: parseFloat(data?.coordinate?.split(',')[1]),
  };
  const transactionStatus = data?.manualTransaction?.status || 'Tidak Aktif';

  const handleOpenModal = ({ type }) => {
    dispatch(setMessageAction({ key: 'block-pin', message: '' }));
    dispatch(setMessageAction({ key: 'resend', message: '' }));
    setModal({ type, isOpen: true });
  };
  const handleCloseModal = () => {
    setModal({ type: 'resend-account', isOpen: false });
  };
  const handleSubmitForm = (payload) => {
    if (data?.isSuspend && modal.type === 'open-suspend') {
      dispatch(openSuspendMerchant({ id, payload }));
      return;
    }
    if (modal.type === 'block-pin') {
      dispatch(blockPinMerchant({ id }));
      return;
    }
    if (modal.type === 'suspend') {
      dispatch(createSuspendMerchant({ id, payload }));
    }
    if (modal.type === 'resend-account') {
      dispatch(resendMerchantAccount(id));
    }
    if (modal.type === 'non-active') {
      dispatch(turnOffTransactionManual());
    }
    if (modal.type === 'ubah-agen') {
      const params = {
        agenId: payload.agenId,
        startDate:
          payload.type === 'Sementara'
            ? dayjs(payload.startDate).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD'),
        endDate:
          payload.type === 'Sementara'
            ? dayjs(payload.endDate).format('YYYY-MM-DD')
            : '',
      };
      dispatch(fetchUpdateAgen(id, params));
    }
  };
  const column = [
    { heading: 'Tanggal Aktif', value: 'startDate' },
    { heading: 'Duration', value: 'duration' },
    {
      heading: 'Status',
      value: ({ status }) => (
        <Badge
          color={historyStatus[status]}
          style={{ textTransform: 'capitalize', fontWeight: 400 }}
        >
          {status}
        </Badge>
      ),
    },
    {
      heading: 'Alasan Pengajuan',
      value: ({ reasonRequest, description }) =>
        reasonRequest === 'Lainnya'
          ? `${reasonRequest}:${description}`
          : reasonRequest,
    },
    { heading: 'Alasan Status', value: 'reasonRejected' },
    { heading: 'Petinjau', value: 'reviewer' },
  ];

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'Data Pangkalan LPG 3 Kg',
        to: '/merchant/setting-data-merchant',
      },
      'Detail',
    ]);
    dispatch(fetchSettingMerchantDetail(id, isShowData));
    dispatch(setFormAction({ key: 'edit', form: null }));
  }, []);

  useEffect(() => {
    if (showNotes) {
      dispatch(fetchTransactionManualList({ nextPage: 1, initial: true }));
    }
  }, [showNotes]);

  useEffect(() => {
    if (blockPin?.message && blockPin?.loading === false) {
      setModal({ type: 'block-pin', isOpen: false });
      dispatch(fetchSettingMerchantDetail(id, isShowData));
    }
  }, [blockPin]);

  useEffect(() => {
    let reload = null;
    if (
      (resend.message || deactivate.message) &&
      resend?.error?.code !== 429
    ) {
      handleCloseModal();
      reload = setTimeout(() => navigate(0), 3000);
    }
    if (
      resend?.message?.includes('Silahkan coba setelah 5 menit!') &&
      !resend?.loading &&
      resend?.error?.code === 429
    ) {
      handleCloseModal();
      setModalInfo(true);
      const time = new Date();
      time.setSeconds(time.getSeconds() + resend?.error?.data?.countdown);
      restart(time);
      setIsTimer(true);
    }
    return () => clearTimeout(reload);
  }, [resend.message, deactivate.message]);

  useEffect(() => {
    setLastUpdate(new Date().getMilliseconds());
  }, [histories]);

  useEffect(() => {
    dispatch(fetchSettingMerchantDetail(id, isShowData));
  }, [isShowData]);

  const handleIdentityUpload = async (files) => {
    const image = URL.createObjectURL(files[0]);
    const blob = await fetch(image).then((res) => res.blob());
    const base64 = await blobToBase64(blob);
    const identityImage = base64.slice(base64.search(',') + 1, base64.length);
    dispatch(identityImageUpload(id, identityImage));
  };

  const onClickHistoryAgent = () => {
    navigate(`/merchant/setting-data-merchant/agent-history/${id}`);
  };

  return (
    <div>
      {!data?.isIdentityImageExist && (
        <Banner
          className={styles.banner}
          desc={<b>Pangkalan belum melakukan onboarding!</b>}
          icon={<IconWarning />}
          type={'warning'}
        />
      )}
      <div className={styles.cardTitle}>
        <div>
          <h5>{data.storeName}</h5>
          {data.isSuspend && <p>Suspend</p>}
        </div>
        <div className={styles.containerButton}>
          <Button
            className={styles.btnIcon}
            onClick={() => setIsShowData(!isShowData)}
          >
            {detailLoading ? <LoadingBars className={styles['loading-bars']} size="1" /> : <IcEye />}
            {isShowData ?
              <>Sembunyikan Data</>
              :
              <>Tampilkan Data </>
            }
          </Button>
        </div>
      </div>
      <DetailInfoMerchant
        data={data}
        dataDetailUser={dataDetailUser}
        handleEdit={() =>
          navigate(`/merchant/setting-data-merchant/edit/${id}`)
        }
        handleResendAccount={() => handleOpenModal({ type: 'resend-account' })}
        handleSuspend={() => handleOpenModal({ type: 'block-pin' })}
        handleUpload={handleIdentityUpload}
        loading={loading}
        modalUpdaload={modalUpdaload}
        onClickHistoryAgent={onClickHistoryAgent}
        setModalAgent={setModal}
        setModalUpload={setModalUpload}
        timer={
          resend?.error?.code === 429 && isTimer
            ? `(${minutes ?? ''}:${seconds ?? ''})`
            : ''
        }
      />
      {data?.manualTransaction
        ? Object.keys(data.manualTransaction).length !== 0 && (
          <Card mb="lg" mt="md" pb="0" radius="md" withBorder>
            <Card.Section inheritPadding py="xs" withBorder>
              <Flex justify="space-between">
                <p className={styles.sectionTitle}>Pencatatan Manual</p>
                <div>
                  <Button onClick={() => setShowNotes(true)} outlined>
                    Riwayat Aktivasi Pencatatan Manual
                  </Button>
                  {transactionStatus === 'Aktif' && (
                    <Button
                      className={styles.buttonNonActive}
                      onClick={() => handleOpenModal({ type: 'non-active' })}
                      style={'danger'}
                    >
                      Nonaktifkan
                    </Button>
                  )}
                </div>
              </Flex>
            </Card.Section>
            <ul className={styles.notes}>
              <li>
                <div>
                  <p style={{ marginTop: 0 }}>Status</p>
                  <Badge
                    className={styles.badge}
                    style={{
                      '--bg':
                        transactionStatus === 'Aktif' ? '#44AB4A' : '#E32935',
                    }}
                  >
                    {transactionStatus}
                  </Badge>
                </div>
                {transactionStatus === 'Aktif' && (
                  <>
                    <div>
                      <p>Jangka Waktu</p>
                      <p>
                        {formatDateTime(data?.manualTransaction.startDate)} -{' '}
                        {formatDateTime(data?.manualTransaction.endDate)}
                      </p>
                    </div>
                    <div>
                      <p>Petinjau</p>
                      <p>{data?.manualTransaction.reviewer}</p>
                    </div>
                  </>
                )}
              </li>
            </ul>
          </Card>
        )
        : ''}
      <Card mb={10} radius="md" withBorder>
        <Card.Section inheritPadding py="xs" withBorder>
          <Group position="apart">
            <p style={{ marginBlock: 0 }}>Titik Koordinat</p>
            <p style={{ marginBlock: 0 }}>{data?.coordinate}</p>
          </Group>
        </Card.Section>
        <div className={styles.mapContainer}>
          <IconMap />
          <Button
            className={styles.btnIcon}
            onClick={() => setShowMap(true)}
            outlined
          >
            <IcMap /> Tampilkan Map
          </Button>
        </div>
      </Card>
      {/* LOG SUSPEND */}
      <Card
        display={data?.suspendHistory?.length ? 'block' : 'none'}
        mt="md"
        radius="md"
        withBorder
      >
        <Card.Section inheritPadding py="xs">
          <Group position="apart">
            <p className={styles.sectionTitle}>LOG SUSPEND</p>
          </Group>
        </Card.Section>
        <ul className={styles.logs}>
          {data?.suspendHistory?.map((history, index) => (
            <li key={index}>
              <div>
                <p>Admin</p>
                <p>{history.username}</p>
              </div>
              <div>
                <p>Tanggal Suspend</p>
                <p>{history.date}</p>
              </div>
              <div>
                <p>Alasan</p>
                <p>{history.reason}</p>
              </div>
              <div>
                <p>Gambar</p>
                {history.photo ? (
                  <Button
                    onClick={() => {
                      setImage(history.photo);
                      setShowImage(true);
                    }}
                    variant="outline"
                  >
                    Lihat Gambar
                  </Button>
                ) : (
                  <p>Tidak ada gambar.</p>
                )}
              </div>
            </li>
          ))}
        </ul>
      </Card>
      <ModalSettingMerchant
        data={data}
        handleSubmit={handleSubmitForm}
        merchantName={data.storeName}
        onClose={handleCloseModal}
        open={modal.isOpen}
        timer={{ minutes: minutes, seconds: seconds }}
        type={modal.type}
        withLine={modal?.withLine}
      />
      <Modal
        centered={true}
        onClose={() => setShowImage(false)}
        opened={showImage}
      >
        <Button
          className={styles.buttonClose}
          onClick={() => setShowImage(false)}
        >
          <span>Tutup Gambar</span>
          <IconClose style={{ fill: '#ffffff' }} />
        </Button>
        <img alt="Photo Log Suspend" src={image} />
      </Modal>
      <Modal
        centered
        lastUpdate={lastUpdate}
        onClose={() => setShowNotes(false)}
        opened={showNotes}
        size={'70%'}
        title={'Riwayat Aktivasi Pencatatan Manual'}
      >
        <div className={styles.tableNotes}>
          {deactivate.loading ? (
            <p style={{ textAlign: 'center' }}>Memuat data...</p>
          ) : (
            <DataTable column={column} data={histories} withIndex />
          )}
        </div>
      </Modal>
      <Modal
        centered
        className={styles.modalInfo}
        onClose={() => setModalInfo(false)}
        opened={modalInfo}
        withCloseButton={false}
      >
        <div className={styles.modalInfoContent}>
          <h4>Kirim Ulang Akun</h4>
          <p>
            Anda telah melakukan permintaan kirim ulang akun. Harap tunggu
            hingga <span> {`${minutes}:${seconds}`}</span>
          </p>
        </div>
        <div className={styles.modalInfoAction}>
          <Button onClick={() => setModalInfo(false)} style={'blue'}>
            Tutup
          </Button>
        </div>
      </Modal>
      <ModalMap
        centerPoint={centerPoint}
        setShowMap={setShowMap}
        showMap={showMap}
      />
      <Modal centered={true} opened={sync.loading} withCloseButton={false}>
        <div className={styles.modalProgress}>
          <Loader />
          <div>
            <h4>Proses Sinkronisasi Data Monica</h4>
            <span>
              Mohon tunggu, kami sedang menyamakan data pangkalan dengan data
              Monica.
            </span>
          </div>
        </div>
      </Modal>
      <Modal
        centered={true}
        opened={modalCtx?.name === 'sync' && modalCtx?.opened}
        withCloseButton={false}
      >
        <div className={styles.modalSyncError}>
          <h3>Sinkronisasi Data Gagal</h3>
          <div className={styles.line} />
          <span>
            Terjadi kesalahan saat proses sinkronisasi data dengan Monica,
            silakan coba sinkronisasi data kembali
          </span>
          <div className={styles.containerContent}>
            <IconInfoFull />
            <div className={styles.column}>
              <strong>Alasan proses sinkronisasi data gagal:</strong>
              <ol>
                {modalCtx?.data?.reasons?.map((reason, index) => (
                  <li key={index}>{reason}</li>
                ))}
              </ol>
            </div>
          </div>
          <Button onClick={() => setModalCtx(null)} style={'default'}>
            Tutup
          </Button>
        </div>
      </Modal>
      {/* <Modal
        onClose={() => setModalAgent(false)}
        open={modalAgent}
        size={'lg'}
      >
        <EditAgentForm handleSubmitAgent={handleSubmitAgent} onClose={() => setModalAgent(false)}/>
      </Modal> */}
    </div>
  );
}

export default DetailSetting;
